import { flatMap } from "lodash";
import React from "react";
import { TUseStepOption } from "../../../api/endpoints/SubsetOption";
import SelectAllControl from "../SelectAllControl";
import UseStepControl from "././UseStepControl";

export type TUseStepValue = {
  step: string;
  use: number;
};

const useStepsToOptions = (spec: TUseStepOption): Array<TUseStepValue> => {
  const { step, use } = spec.value;

  return flatMap(use, (useItem, index) => {
    const dayRanges = step[index];

    return dayRanges.map(dayRange => {
      const use = parseInt(useItem, 10);

      return {
        use,
        step: dayRange
      };
    });
  });
};

const UseStepSelector = (props: {
  values: Array<TUseStepValue>;
  spec: TUseStepOption;
  onChange: (values: Array<TUseStepValue>) => void;
}) => {
  const { spec, values, onChange } = props;

  const options = useStepsToOptions(spec);

  return (
    <div>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />
      <UseStepControl options={options} selection={values} onChange={onChange} />
    </div>
  );
};

export default UseStepSelector;
